const {
    GET_OPEN_BALANCE_REPORT,
    OPEN_BALANCE_REPORT_NOTIFICATION,
  } = require('redux/admin-constants');

  const initialState = {
    openBalanceReport: [],
    openBalanceReportNotification: {
      message: '',
      isSuccess: 1,
    },
  }; 

  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_OPEN_BALANCE_REPORT: {
        return {
          ...state,
          openBalanceReport: payload,
        };
      }
     
      case OPEN_BALANCE_REPORT_NOTIFICATION: {
        return {
          ...state,
          openBalanceReportNotification: payload.message
            ? payload
            : initialState.openBalanceReportNotification,
        };
      }
      default:
        return state;
    }
  };
  
  export default reducer;